<template>
  <div>
    <v-dialog v-model="showDiscrepancyDialog" width="1250">
      <v-row class="pa-0 ma-0 dialogXScrollHidden">
        <v-col cols="12" sm="12" md="12" lg="12" class="pa-0 ma-0">
          <v-card class="add-menu containerbox pa-0 ma-0">
            <v-card-title dense class="subtitle-2 primary customwhite--text">
              Log Discrepancy
              <v-spacer></v-spacer>
              <v-btn outlined class="pa-0" dense small title="Close" color="customwhite" @click="closeDialog">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <template>
              <v-row class="px-5 my-1 py-0 pb-3">
                <v-col cols="12" sm="12" md="12" lg="12" class="px-5 mx-0 my-0">
                  <v-row class="py-0 my-0">
                    <v-col cols="12" sm="12" md="12" lg="6" class="px-5 mx-0 py-1">
                      <v-template class="ma-0 pa-0 secondary--text">Project</v-template> <br />
                      <div class="ma-0 pa-0 f-bold f-12"> {{ projectName }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" :lg="isOrderDisabled?6:3" class="px-5 py-1">
                      <v-text-field :disabled="isOrderDisabled" color="primarytext" v-model="discrepancy.orderNo" outlined
                        label='Order Number' persistent-placeholder clearable dense  :rules="required"
                        @input="discrepancy.orderNo = discrepancy.orderNo?.toUpperCase()"
                        @keydown.enter="onClickSearchOrder" />
                    </v-col>
                    <v-col v-if="!isOrderDisabled" cols="12" sm="12" md="12" lg="1" class="pl-5  py-1">
                      <v-btn class="btn-style" outlined elevation="1" color="primarytext" @click="onClickSearchOrder()">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col v-if="!isOrderDisabled" cols="12" sm="12" md="12" lg="2" class="pl-1 py-1">
                      <v-btn class="btn-style" outlined elevation="1" color="primarytext" @click="onClickSearchOrder()">
                        No Order
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-form ref="discreapancyForm" lazy-validation @submit.prevent="submit">
                    <v-row class="py-0 my-0">
                      <v-col cols="12" sm="12" md="12" lg="6" class="px-5 py-1">
                        <v-text-field ref="waybillField" :disabled="disableStagingLoc" color="primarytext" v-model="discrepancy.WayBill"
                          outlined label='Waybill' persistent-placeholder clearable dense PartDetails :rules="required"
                          @input="discrepancy.WayBill = discrepancy.WayBill?.toUpperCase()" />
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="px-5 py-1">
                        <v-text-field :disabled="disableStagingLoc" color="primarytext" v-model="discrepancy.PackSlip"
                          outlined label='Packing Slip' persistent-placeholder clearable dense PartDetails
                          :rules="required" @input="discrepancy.PackSlip = discrepancy.PackSlip?.toUpperCase()" />
                      </v-col>

                    </v-row>
                    </v-form>
                    <v-form ref="partForm" lazy-validation @submit.prevent="submit">
                      <v-row class="py-0 my-0">
                        <v-col cols="12" sm="12" md="12" lg="6" class="px-5">
                          <v-autocomplete :disabled="reasonList?.length == 0" color="primarytext" persistent-placeholder
                            outlined class="ma-0" v-model="discrepancy.reason" dense :items="reasonList" label="Reason"
                            item-text="reason" item-value="reason_key" required :rules="required"
                            @change="onChangeReason">
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="2" class="px-1 pl-4 py-1">
                          <v-switch :disabled="disableUnknownPart" class="ma-1 d-inline-block" dense
                            v-model="discrepancy.unknownPartFlag" label="Unkown Part Number" inset
                            color="primarytext" @change="onSwitchChange"></v-switch>
                        </v-col>
                        <v-col v-if="discrepancy.unknownPartFlag" cols="12" sm="12" md="12" lg="4"
                          class="px-1 py-1 pr-5">
                          <v-text-field color="primarytext" v-model="discrepancy.unknownPartNum" outlined
                            label='Description' persistent-placeholder clearable dense PartDetails
                            @input="onInputPartNum" :rules="required" />
                        </v-col>
                      </v-row>
                      <v-row class="py-0 my-0">
                        <v-col cols="12" sm="12" md="12" lg="1" class="pl-3 pr-1 py-1">
                          <v-switch :disabled="disableEmpty" class="ma-1 d-inline-block" dense
                            v-model="discrepancy.emptyBox" label="Empty Box" inset color="primarytext"></v-switch>
                        </v-col>  
                        <v-col cols="12" sm="12" md="12" :lg="showPartDetails?4:6" class="pl-5 pr-1 py-1">
                          <div class="searchInput">
                            <v-text-field :disabled="disablePartNum" color="primarytext" persistent-placeholder
                              :rules="!disablePartNum?required:[]" v-model="searchPartNum" @input="inputPartNum" label="Part Number"
                              outlined @click:clear="clearPartNum" clearable dense class="ma-0 f-uppercase">
                            </v-text-field>
                            <div v-if="showPartNum"
                              v-bind:class="(this.$vuetify.theme.dark) ? 'darkResultBox' : 'resultBox'">
                              <ul>
                                <li v-for="item in partResultList" v-bind:key="item.part_id"
                                  @mousedown="showPartDesc(item)" style="padding:2px;">
                                  <span>
                                    <b> {{ item.PartNo }} </b><br />
                                    {{ item.Description }}<br />
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </v-col>
                        <!-- Description of Part Number -->
                        <v-col v-if="showPartDetails" cols="12" sm="12" md="12" lg="2" class="px-3 py-0 ma-0 pr-5 ">
                          <b>{{ partNum }}</b><br />
                          {{ partDesc }}
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="3" class="pl-5 pr-5 py-1">
                          <v-text-field :disabled="disableUnit" color="primarytext" v-model="discrepancy.unit" outlined
                            label='Unit' persistent-placeholder clearable dense PartDetails
                            :rules="!disableUnit ? required : []" @input="onUnitInput" />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="2" class="pl-5 pr-1 py-1">
                          <v-text-field :disabled="disabledQty" color="primarytext" v-model="discrepancy.qty" outlined
                            label='Qty' persistent-placeholder clearable dense :rules="!disabledQty ? qtyRule : []" />
                        </v-col>
                      </v-row>
                      <v-row class="pb-4">
                        <v-col cols="12" sm="12" md="12" lg="5" class="px-5 py-1"></v-col>
                        <v-col cols="12" sm="12" md="12" lg="3" class="px-5 py-1">
                          <v-btn :disabled="disableAdd" class="btn-style " outlined elevation="1" color="primarytext"
                            @click="onClickAddPart()">
                            <v-icon>mdi-plus</v-icon> Add Part
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" class="px-5 py-1">
                        <v-data-table :headers="partNumHeader" :hide-default-footer="PartDetails?.length < 9"
                          :items="PartDetails" item-key="line_id">
                          <!-- TO show Part number with description -->
                          <template v-slot:item.Part#="{ item }">
                            {{ item["Part#"] }}<br />
                          </template>
                          <!-- To show all chips -->

                          <template v-slot:item.actions="{ item }">
                            <v-icon color="error" title="Delete Draft Order" small class="mr-2" @click="onClickDelete(item)">
                        mdi-delete
                      </v-icon>
                            </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-form v-if="stage_bin_key" ref="changeLpn" lazy-validation @submit.prevent="submit">
                      <v-row class="pt-4">

                        <v-col cols=" 12" sm="12" md="12" lg="5" class="py-0 my-0 px-5">
                          <v-text-field color="primarytext" v-model="discrepancy.LPN" label="LPN" outlined clearable
                            dense :rules="searchLPNRule" persistent-placeholder @keypress="lpnNumFormat($event, lpn)">
                          </v-text-field>
                          <p v-if="showLpnMessage" class="error--text px-2">You must use an LPN different than one specifed for regular receipts</p>
                        </v-col>

                        <v-col cols="12" sm="12" md="12" lg="1" class="py-0 my-0 px-0">
                          <v-btn class="btn-style" outlined elevation="1" color="primarytext"
                            @click="getDiscrepancyLpn()" :disabled="disableTargetLPN">
                            <v-icon>mdi-cart-outline</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="1" class="py-0 my-0 px-0">
                          <v-btn class="btn-style" outlined elevation="1" color="primarytext"
                            @click="onClickLpnValidate()" :disabled="disableTargetLPN">
                            Validate
                          </v-btn>
                        </v-col>
                      </v-row>
                      </v-form>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12" class="px-6">

                        <fieldset class="px-3 fieldsetstyle">
                          <legend class="secondary--text pa-2 font-weight-medium"> Company Details
                          </legend>
                          <v-row justify="center pt-8 pb-5">
                            <v-col cols="12" sm="12" md="12" lg="12" class="pa-2 pb-0">
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" :rules="required" persistent-placeholder
                                    v-model="discrepancy.Last"
                                    @input="discrepancy.Last = discrepancy.Last?.toUpperCase()" class="ma-0"
                                    label="Name" outlined clearable dense>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" :rules="required" persistent-placeholder
                                    v-model="discrepancy.Company"
                                    @input="discrepancy.Company = discrepancy.Company?.toUpperCase()" class="ma-0"
                                    label="Company Name" outlined clearable dense>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" :rules="required" persistent-placeholder
                                    v-model="discrepancy.Address1"
                                    @input="discrepancy.Address1 = discrepancy.Address1?.toUpperCase()" class="ma-0"
                                    label="Address1" outlined clearable dense>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" v-model="discrepancy.Address2"
                                    persistent-placeholder class="ma-0" label="Address2"
                                    @input="discrepancy.Address2 = discrepancy.Address2?.toUpperCase()" outlined
                                    clearable dense>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" :rules="required" persistent-placeholder
                                    v-model="discrepancy.City" label="City"
                                    @input="discrepancy.City = discrepancy.City?.toUpperCase()" class="ma-0" outlined
                                    clearable dense>
                                  </v-text-field>
                                </v-col>
                                <v-col v-if="showStateDrop" cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-autocomplete color="primarytext" :rules="required" persistent-placeholder
                                    v-model="discrepancy.State" class="ma-0" :items="stateData" item-text="States"
                                    label="State/Province/Region" outlined item-value="StateKey" dense
                                    :menu-props="{ maxHeight: 150 }">
                                  </v-autocomplete>
                                </v-col>
                                <v-col v-else cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" persistent-placeholder :rules="stateRule"
                                    v-model="discrepancy.State"
                                    @input="discrepancy.State = discrepancy.State?.toUpperCase()" class="ma-0"
                                    label="State/Province/Region" name="state" outlined clearable dense>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" persistent-placeholder :rules="postalCodeNonUS"
                                    v-model="discrepancy.Zip" label="Postal Code" outlined class="ma-0" clearable dense
                                    v-if="discrepancy.Country !== 'USA'" @input="postal = postal.toUpperCase()"
                                    maxlength="20">
                                  </v-text-field>
                                  <v-text-field color="primarytext" v-model="discrepancy.Zip" label="Postal Code"
                                    name="postal" outlined clearable dense v-else maxlength="10" :rules="zipcode"
                                    persistent-placeholder @keypress="postalCodeFormatPostal($event, postal)">
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-autocomplete color="primarytext" persistent-placeholder :rules="required" attach
                                    outlined v-model="discrepancy.Country" :items="countryData" item-text="Country"
                                    item-value="CountryId" label="Country" dense class="ma-0"
                                    @change="countrySelected()" :menu-props="{ maxHeight: 150 }">
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                                  <v-text-field color="primarytext" @keypress="isNumber($event, 'hypen')"
                                    persistent-placeholder
                                    :rules="phone?.length > 0 || cell?.length > 0 ? [] : required"
                                    v-model="discrepancy.Phone" class="ma-0" label="Phone" outlined clearable dense>
                                  </v-text-field>
                                </v-col>
                              </v-row>

                            </v-col>
                          </v-row>
                        </fieldset>
                      </v-col>
                    </v-row>
                </v-col>
              </v-row>
            </template>
            <v-divider></v-divider>
            <v-card-actions class="pt-3 pb-3 pr-4">
              <v-spacer></v-spacer>
              <!-- Add company page button -->
              <v-btn :disabled="!PartDetails.length" outlined class="ma-1 mx-1 btn-style" color="primarytext " @click="onClickDiscrepancySubmit()">
                Submit
              </v-btn>
              <v-btn color="secondary" outlined dense class="ma-2 pl-2 ml-5 btn-style" @click="closeDialog()"
                elevation="1">
                Quit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </div>
</template>
<script>
//import utility from "@/shared/utility";
import EncryptUtility from "../utility/js/encrypt-utility";
import commonApiService from "../common/js/common-api-service";
import receiveService from "./js/receive-srvice";
import utility from "@/shared/utility";
import PrinterDetails from "../common/printer-details.vue";
export default {
  props: {
    projectName: String,
    orderNum: String,
    showDiscrepancyDialog: Boolean,
    proj_key: String,
    ord_key: String,
    stage_bin_key: String,
    disableOrder: Boolean,
    ordNo: String
  },
  data() {
    return {
      discrepancy: {
        unit: "",
        ProjKey: "",
        OrdNo: "",
        unknownPartNum: "",
        OrdType: "",
        PackSlip: "",
        WayBill: "",
        Reference: "",
        Comments: "",
        LPN: "",
        BinKey: "",
        UserKey: "",
        lbl_size: "",
        printer_type: "",
        searchPartNum: "",
        Company: "",
        First: "",
        Last: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip: "",
        Country: "217",
        Phone: "",
        PartDetails: [],
        reason: "",
        emptyBox: false,
        
        unknownPartFlag: false,
        description: "",
        orderNo: "",
      },
      partObj: {
        PartNum: "",
        PartDesc: "",
        Qty: 0,
        Unit: "",
        ReasonKey: 0,
        CID: 0
      },
      PartDetails: [],
      disabledQty: true,
      showLpnMessage:false,
      partResultList: [],
      qtyRule: [
        (v) => parseInt(v) > 0 || "Field should be greater than 0",
        (v) =>
          parseInt(v) < 2147483647 || "Field should be less than 2,147,483,647",
      ],
      required: [(v) => !!v || "Field is required"],
      showPartNum: false,
      disablePartNum: true,
      searchLPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",

      ],
      disableEmpty: true,
      discrepancyDisplayArrayData: [],
      showDiscrepancyDetails: true,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      reasonList: [],
      countryData: [],
      stateData: [],
      showStateDrop: false,
      disableUnknownPart: true,
      lpnObj:{},
      disableUnit: true,
      disableAdd: true,
      showPartDetails: false,
      primaryLabelSize: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
      primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
      primaryPrinterType: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
      receiveType: "",
      isOrderDisabled: false,
      partNumHeader: [
        {
          text: "Part#",
          value: "PartNum",
          class: "primary customwhite--text",
        },
        {
          text: "Part Desc",
          value: "PartDesc",
          class: "primary customwhite--text",
        },
        {
          text: "Unit",
          value: "Unit",
          class: "primary customwhite--text",
        },
        {
          text: "Qty",
          value: "Qty",
          class: "primary customwhite--text",
        },
        {
          text: "Action",
          value: "actions",
          class: "primary customwhite--text",
        },],
    }
  },
  async created() {

  },
  computed: {},

  mounted() {
    this.isOrderDisabled = this.disableOrder
    this.discrepancy.orderNo = this.ordNo || this.orderNum || ""
    this.discrepancy.BinKey=this.stage_bin_key
    this.onClickRouteToDiscrepancy()
    this.receiveType = this.$route.path.replace("/", "")?.split("/")[1];
    const lpnDetails = this.getLpnDetails();
    this.lpnObj=lpnDetails
  },
  methods: {
    onSwitchChange(){
      this.disablePartNum=this.discrepancy.unknownPartFlag
    },
    onUnitInput(val) {
      if (!this.disableUnit) this.disableAdd = !val || parseInt(val) <= 0;
    },
    onClickDelete(item){
      this.PartDetails=this.PartDetails.filter((x)=>x.CID!=item.CID)
    },
    lpnNumFormat(event, num) {
      this.discrepancy.LPN = utility.formatLPNNumber(event, num);
      this.discrepancy.LPN==this.lpnObj.lpn? this.showLpnMessage=true:this.showLpnMessage=false;
    },
    onInputPartNum() {
      this.disableAdd = false;
      this.disabledQty = false;
      this.discrepancy.qty = 1
    },
    getLpnDetails() {
      try {
        return JSON.parse(
          EncryptUtility.localStorageDecrypt("receivelpnDetails")
        );
      } catch {
        return null;
      }
    },
    
    onChangeReason() {
      this.clearPartItem()
      if (this.discrepancy.reason == 3) {
        this.disabledQty = false
        this.discrepancy.emptyBox = true;
        this.disableEmpty = true;
        this.disableUnknownPart = true;
        this.disablePartNum = true;
        this.disableUnit = true;
        this.discrepancy.qty = 1;
        this.disableAdd = false;
      
      }
      else if (this.discrepancy.reason == 6) {
        this.discrepancy.emptyBox = false;
        this.discrepancy.unknownPartFlag = true;
        this.disableEmpty = true;
        this.disableUnknownPart = false;
        this.disablePartNum = true;
        this.disableUnit = true;
        
      }
      else {
        this.discrepancy.emptyBox = false;
        this.disablePartNum = false;
        this.disableUnknownPart = false;
      }
      this.$nextTick(() => this.$refs.partForm?.resetValidation());
    },
    async onClickRouteToDiscrepancy() {
      this.countrySelected();
      this.showDiscrepancyDialog = true;
      if (this.ord_key) {
        this.getReasonData(this.ord_key)
        let data = await commonApiService.countryListNew(this.userId, "", 1, "get");
        this.countryData = data.CountryInfo;
        let address = await this.getReasonAddress()
        this.addressMaping(address)

      }
    },

    async onClickAddPart() {
      if (this.$refs.partForm?.validate()) {
        if(this.discrepancy.emptyBox){
          this.partObj = {
          PartNum: "#EmptyBox",
          PartDesc: "Empty Box",
          Qty: this.discrepancy.qty,
          Unit: "",
          ReasonKey: this.discrepancy.reason,
          CID: Math.max(...this.PartDetails.map(p => p.CID), 0) + 1
        }
      }
        
        else if(this.discrepancy.unknownPartFlag){
          this.partObj = {
          PartNum: "#UNKNOWNPART",
          PartDesc: this.discrepancy.unknownPartNum,
          Qty: this.discrepancy.qty,
          Unit: "",
          ReasonKey: this.discrepancy.reason,
          CID: Math.max(...this.PartDetails.map(p => p.CID), 0) + 1
        } 
      }
      else {
          this.partObj.Qty = this.discrepancy.qty;
          this.partObj.Unit = this.discrepancy.unit;
          this.partObj.ReasonKey = this.discrepancy.reason;
          this.partObj.CID = Math.max(...this.PartDetails.map(p => p.CID), 0) + 1;
        }
        this.addPartToDetails();
        return;
      }

      this.partObj.Qty = this.discrepancy.qty;

     

      if (!this.discrepancy.unknownPartFlag&& this.discrepancy.emptyBox) {
        const disObj = {
          proj_key: this.proj_key,
          pass: 2,
          Unit: this.discrepancy.unit,
          UserId: this.userId
        };

      
         await receiveService.postPartCheck("post", disObj, false);
       
        this.partObj.Unit = this.discrepancy.unit;
      }

      this.addPartToDetails();
    },

    addPartToDetails() {
      this.PartDetails.push(this.partObj);
      this.partObj = {
        PartNum: "",
        PartDesc: "",
        Qty: 0,
        Unit: "",
        ReasonKey: 0,
        CID: ""
      };
      this.clearPartItem();
      this.discrepancy.reason = "";
      this.$refs.partForm?.resetValidation();

    },
    clearPartItem() {
      this.disableAdd = true;
      this.disabledQty = true;
      this.discrepancy.qty = "";
      this.discrepancy.unit = "";
      this.discrepancy.emptyBox = false;
      this.discrepancy.unknownPartNum = "";
      this.discrepancy.unknownPartFlag = false;
      this.disableUnknownPart = true;
      this.showPartDetails = false;
      this.clearPartNum()
      this.disablePartNum = true
      this.disableUnit = true;
    },
    async addressMaping(address) {
      this.discrepancy.Address1 = address[0].address1
      this.discrepancy.Last = address[0].Last
      this.discrepancy.First = address[0].First
      this.discrepancy.Company = address[0].Company
      this.discrepancy.Address2 = address[0].address2
      this.discrepancy.City = address[0].City
      this.discrepancy.State = address[0].State
      this.discrepancy.Zip = address[0].Zip
      this.discrepancy.Country = parseInt(address[0].Country_id)
      this.discrepancy.Phone = address[0].Phone
    },
    async onClickDiscrepancySubmit() {
      this.discrepancy.ProjKey=this.proj_key;
      this.discrepancy.OrdNo=this.orderNum;
      this.discrepancy.OrdType=this.receiveType;
      this.discrepancy.discrepancy=this.stage_bin_key;
      this.discrepancy.UserKey=this.userId;
      this.discrepancy.lbl_size=this.primaryLabelSize;
      this.discrepancy.printer_type=this.primaryPrinterType;
      this.discrepancy.PartDetails=this.PartDetails
      let discrepancyObj={
        UserId:this.userId,
        json:JSON.stringify(this.discrepancy)
      } 
      if(this.$refs.changeLpn?.validate() && this.$refs.discreapancyForm?.validate()){
        let res=await receiveService.postDiscrepancySave("post",discrepancyObj,false)
        if(res){
          res.Info.LabelInfo
        ? PrinterDetails.printLabelDataArray(
          res.Info.LabelInfo,
            this.primaryName
          )
        : ""
          this.closeDialog()
        
        }
      }
      
    },

    async getReasonAddress() {
      let addressObj = {
        UserId: this.userId,
        po_so: this.receiveType == "SO" ? "S" : "P",
        ord_key: this.ord_key,
      };
      let discrepancyAddress = await receiveService.getAddressData(
        "post",
        addressObj,
        false
      );
      return discrepancyAddress
    },

    async countrySelected() {
      this.discrepancy.State = "";
      let data = await commonApiService.countryListNew(this.userId, "", 1, "get");
      this.countryData = data.CountryInfo;
      this.discrepancy.Zip = "";
      let country = this.countryData.filter((x) => x.CountryId == this.discrepancy.Country)[0].Country
      let data1 = await commonApiService.countryListNew(this.userId, country, 2, "get");
      this.stateData = data1.StateInfo;
      if (this.stateData.length !== 0) {
        this.showStateDrop = true;
      } else {
        this.showStateDrop = false;
      }

    },
    async inputPartNum() {
      if (this.searchPartNum) {
        if (this.searchPartNum.length > 2) {
          let obj = {
            UserId: this.userId,
            proj_key: this.proj_key,
            SearchStr: this.searchPartNum,
          };
          this.showPartNum = true;
          let resp = await receiveService.postPartNum("post", obj, false, true);
          this.partResultList = resp.Resultset
        }
        else {
          this.clearPartNum()
        }
      }
    },
    clearPartNum() {
      this.showPartNum = false;
      this.partResultList = []
      this.searchPartNum = ""
      this.showPartDetails = false;
      this.partDesc = "";
      this.partNum = ""

    },
    showPartDesc(item) {
      this.showPartNum = false;
      this.partDesc = item.Description;
      this.showPartDetails = true;
      this.partNum = item.PartNo;
      this.searchPartNum = item.PartNo;
      this.disableUnit = !item.barcoded
      this.disableAdd = item.barcoded;
      this.partObj.PartNum = item.PartNo;
      this.partObj.PartDesc = item.Description;
      this.disabledQty = false
      this.discrepancy.qty = 1;
    },
    closeDialog() {
      this.showDiscrepancyDialog = false
      this.$emit("closeDiscrepancyDialog")
    },
    async onClickLpnValidate() {
      let changeLpnObj = {
        UserId: this.userId,
        bin_key: this.stage_bin_key,
        lpn: this.discrepancy.LPN,
        discrep: true,
        proj_key: this.proj_key
      }
      if (this.$refs.changeLpn?.validate()) {
        await receiveService.postChangeLpn("post", changeLpnObj, true)
      }
    },
    async getDiscrepancyLpn() {
      let lpnData = await commonApiService.getNextAvailableLPN(
        "get",
        this.userId
      );
      if (lpnData.message !== "NA") {
        this.discrepancy.LPN = lpnData[0]?.lpn;  
        this.onClickLpnValidate()
      }
    },
    async onClickSearchOrder() {
      if (!this.discrepancy.orderNo) {
        this.discrepancy.orderNo = "ORDER NOT FOUND"
        this.isOrderDisabled = true;
        this.getReasonData(0)
      }
      else {
        let orderSerachObj = {
          proj_key: this.proj_key,
          order: this.discrepancy.orderNo,
          ordtype: this.receiveType,
          UserId: this.userId
        }
        let res = await receiveService.getDiscrepancyOrderDetails("post", orderSerachObj, false)
        if (res) {
          this.addressMaping(res.Result.Data_Info)
          this.discrepancy.WayBill = res.Result.Data_Info.WayBill
          this.discrepancy.PackSlip = res.Result.Data_Info.BackSlip
        }

      }
      this.$nextTick(() => {
        this.$refs.waybillField?.focus();
      });
    },
    async getReasonData(ord_key) {
      let reasonObj = {
        UserId: this.userId,
        ord_key: ord_key,
        proj_key: this.proj_key,
      };
      let reasonData = await receiveService.getReasonList("post", reasonObj, false);
      this.reasonList = reasonData.Result;
    },
  }
};

</script>